export function formatPhoneForWhatsapp(input) {
  if (!input) return null;

  // Remove non-digit characters
  let digits = input.replace(/\D/g, "");

  // Remove leading '0' if present (local format)
  if (digits.startsWith("0")) {
    digits = digits.substring(1);
  }

  // Remove extra 0 after +972 (common mistake)
  if (digits.startsWith("9720")) {
    digits = "972" + digits.substring(4);
  }

  // If starts with '972', keep as is
  else if (!digits.startsWith("972")) {
    digits = "972" + digits;
  }

  // Must be 12 digits (972 + 9)
  if (!/^9725\d{8}$/.test(digits)) {
    return null; // Not a valid Israeli mobile number
  }

  return digits;
}

export const isValidIsraeliPhone = (input) => {
  if (!input) return false;

  const digits = input.replace(/\D/g, ""); // remove non-digit chars

  return (
    (digits.length === 10 && digits.startsWith("0")) || // national
    (digits.length === 12 && digits.startsWith("972")) // international
  );
};
